import { CVUP_ROLE } from '@Domains/Profile';

export const findUserRoles = (roles: string[]) => {
  return {
    cvupCreatorRole: roles.find((role) => role === CVUP_ROLE.CVUP_CREATOR),
    cvupApproverRole: roles.find((role) => role === CVUP_ROLE.CVUP_APPROVER),
  };
};
